<template>
  <div>
    <el-dialog
      :title="this.value.isCreate ? '添加模板' : '修改模板'"
      center
      :visible.sync="visible"
      @closed="onClosed"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form ref="form" :model="form" label-width="120px" size="mini">
        <el-form-item label="名称" prop="name">
          <el-input
            v-model="form.name"
            placeholder="（仅为了方便在后台页面上区分不同模板，不会在游戏里展示）"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <div>
            <el-tabs type="card" v-model="form.activeLanguageTabName">
              <el-tab-pane
                v-for="item in form.languageTemplates"
                :key="item.languageId"
                :name="item.languageId"
              >
                <span slot="label"
                  ><i
                    v-if="item.title.trim() == ''"
                    class="el-icon-info"
                    style="margin-right: 5px; color: red"
                  ></i
                  >{{ `${item.languageName}` }}</span
                >
                <div>
                  <label style="display: block">标题：</label>
                  <el-input v-model="item.title"></el-input>
                </div>
                <div style="margin-top: 5px">
                  <label style="display: block">正文：</label>
                  <el-input
                    type="textarea"
                    rows="15"
                    v-model="item.content"
                  ></el-input>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-form-item>
        <el-form-item v-if="!this.value.isCreate">
          <div style="color: red">
            注意：修改模板会导致已发出的邮件的内容也受到影响，请谨慎使用！
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="submit()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const axios = require("axios");
import util from "@/util";
import bizutil from "@/bizutil";

import ChannelSelector from "../../components/ChannelSelector";

export default {
  data() {
    return {
      visible: true,
      availableLanguages: [], // 多语言集合
      form: {
        name: "", // 模板名称
        activeLanguageTabName: "",
        languageTemplates: [], // 各个语言对应的模板（标题和正文）
      },
    };
  },

  props: {
    value: Object,
  },

  components: {
    ChannelSelector,
  },

  async created() {
    // 查询多语言集合
    await this.getLanguageList();

    if (this.value.isCreate) {
      // 为各个语言构建空模板
      await this.buildEmptyTemplatesForAllLanguages();
    } else {
      this.form.name = this.value.templateData.name;
      this.form.languageTemplates = this.value.templateData.languageTemplates;
      if (this.availableLanguages && this.availableLanguages.length > 0) {
        this.form.activeLanguageTabName = this.availableLanguages[0].id;
      }
    }
  },

  methods: {
    /**
     * 提交表单
     */
    async submit() {
      if (this.form.name.trim() == "") {
        this.$message({
          message: "请填写模板名称",
          type: "error",
        });
        return;        
      }

      let languageTemplates = [];
      for (let e of this.form.languageTemplates) {
        languageTemplates.push({
          language: e.languageId,
          title: e.title,
          text: e.content,
        });
      }

      let apiUrl = "";
      let requestBody = null;
      if (this.value.isCreate) {
        apiUrl = `${util.getBackendApiBase()}/api/admin/v1/mail/addTemplate`;
        requestBody = {
          name: this.form.name,
          templates: languageTemplates,
        };
      } else {
        apiUrl = `${util.getBackendApiBase()}/api/admin/v1/mail/updateTemplate`;
        requestBody = {
          id: this.value.templateData.id,
          name: this.form.name,
          templates: languageTemplates,
        };
      }

      let resData = (
        await axios.post(apiUrl, requestBody, {
          headers: {
            token: bizutil.getLoginUserToken(),
          },
        })
      ).data;
      if (resData.code > 0) {
        // 可能需要重新登录
        if (resData.code == 2004) {
          util.gotoLoginPage();
          return;
        }

        this.$message({
          message: "添加失败",
          type: "error",
        });
        return;
      }

      this.$message({
        message: "添加成功",
        type: "success",
      });

      // 关闭当前对话框
      this.visible = false;
    },

    onClosed() {
      // 向父组件抛出事件
      this.$emit("close");
    },

    /**
     * 为各个语言构建空模板
     */
    async buildEmptyTemplatesForAllLanguages() {
      for (let l of this.availableLanguages) {
        this.form.languageTemplates.push({
          languageId: l.id,
          languageName: l.name,
          title: "",
          content: "",
        });
      }

      if (
        this.form.languageTemplates &&
        this.form.languageTemplates.length > 0
      ) {
        this.form.activeLanguageTabName =
          this.form.languageTemplates[0].languageId;
      }
    },

    /**
     * 查询多语言集合
     */
    async getLanguageList() {
      var resData = (
        await axios.post(
          `${util.getBackendApiBase()}/api/admin/v1/language/getList`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      if (resData.data.languages) {
        for (let l of resData.data.languages) {
          this.availableLanguages.push(l);
        }
      }
    },
  },
};
</script>